<template>
  <div
    @click="handleRadioClick"
    data-dusk="radio-button"
    class="flex-row gap-xs align-items-center radio-input-wrapper"
  >
    <input
        ref="radio"
        class="radio-input"
        v-bind="$attrs"
        :name="groupName"
        :value="value"
        type="radio"
    />
    <label data-dusk="radio-label" class="radio-label" :for="groupName">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  name: "DdRadio",
  props: {
    value: {
      type: [String, Number, Boolean],
      required: true,
    },
  },
  inject: ['groupName'],
  methods: {
    handleRadioClick() {
      this.$refs.radio.checked = true;
      this.$emit('input');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.radio-label {
  line-height: 1;
  margin-bottom: 0;
}
.radio-input {
  // Limited support...
  accent-color: $brand-primary;
  margin: 0;
}
.radio-input-wrapper *,
.radio-input-wrapper {
  cursor: pointer;
}
label {
  color: $text-color !important;;
}
</style>
